enum UserSubscriptionTypes {
    None = 'NONE',
    Basic = 'BASIC',
    FreeTrial = 'FREE_TRIAL',
    Premium = 'PREMIUM',
    Enterprise = 'ENTERPRISE',
}

export default UserSubscriptionTypes;
